import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ed1f471"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container h-full max-w-2xl mx-auto flex flex-col mb-24" }
const _hoisted_2 = { class: "flex-grow flex items-center justify-center" }
const _hoisted_3 = { class: "alert-wrapper container mx-auto p-5" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "icon-wrapper mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-semibold" }, "Measurements Submitted"),
  /*#__PURE__*/_createElementVNode("p", { class: "pt-2 font-medium text-gray-600" }, " Your details will be reviewed by the team on the next working day, excluding weekends and bank holidays. ")
], -1))
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Mark as Complete ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "px-5 py-6" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "font-medium text-center" }, " If you are feeling unwell please refer to your information pack for guidance. "),
    /*#__PURE__*/_createElementVNode("p", { class: "font-medium text-center" }, "For all emergencies call 999.")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_ion_icon, {
                      class: "text-5xl",
                      icon: _ctx.okSquare
                    }, null, 8, ["icon"])
                  ]),
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_ion_button, {
                      id: "complete-button",
                      expand: "block",
                      fill: "outline",
                      onClick: _withModifiers(_ctx.markAsCompleted, ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ])
            ]),
            _hoisted_9
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}